var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.723,
    height: 11.718,
    viewBox: "0 0 11.723 11.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-link",
    "data-name": "Icon ionic-ios-link",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M9.91,17.409l-.034,0a.466.466,0,0,0-.27.127l-1.82,1.82a2.051,2.051,0,0,1-2.9-2.9l1.932-1.932a2.039,2.039,0,0,1,.321-.262,2.07,2.07,0,0,1,.417-.211,1.972,1.972,0,0,1,.423-.1,2,2,0,0,1,.287-.02c.039,0,.079,0,.13.006a2.046,2.046,0,0,1,1.318.592,2.02,2.02,0,0,1,.482.769.443.443,0,0,0,.544.284l.008,0s.006,0,.006,0a.44.44,0,0,0,.3-.538,2.552,2.552,0,0,0-.693-1.155,2.965,2.965,0,0,0-1.622-.825c-.054-.008-.107-.017-.161-.023a2.907,2.907,0,0,0-.313-.017c-.073,0-.146,0-.217.008a2.841,2.841,0,0,0-.456.07c-.031.006-.059.014-.09.023a2.93,2.93,0,0,0-.549.206,2.893,2.893,0,0,0-.78.561L4.234,15.815a2.971,2.971,0,0,0-.859,2.1,2.962,2.962,0,0,0,5.053,2.093l1.839-1.839A.446.446,0,0,0,9.91,17.409Z",
    transform: "translate(0 -5.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4959",
    "data-name": "Path 4959",
    d: "M20.277,4.24a2.968,2.968,0,0,0-4.188,0L14.295,6.034a.453.453,0,0,0,.284.772.458.458,0,0,0,.358-.13l1.8-1.791a2.051,2.051,0,0,1,2.9,2.9L17.7,9.718a2.039,2.039,0,0,1-.321.262,2.07,2.07,0,0,1-.417.211,1.972,1.972,0,0,1-.423.1,2,2,0,0,1-.287.02c-.039,0-.082,0-.13-.006A2.024,2.024,0,0,1,14.345,9a.45.45,0,0,0-.538-.276.455.455,0,0,0-.318.577,2.573,2.573,0,0,0,.668,1.056h0l.006.006a2.966,2.966,0,0,0,1.783.848,2.907,2.907,0,0,0,.313.017q.11,0,.22-.008a3.22,3.22,0,0,0,.544-.09,2.93,2.93,0,0,0,.549-.206,2.893,2.893,0,0,0,.78-.561l1.932-1.932a2.965,2.965,0,0,0-.006-4.191Z",
    transform: "translate(-6.05 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosLink);
export default __webpack_public_path__ + "static/media/ios-link.2896b37cffaf612241451fd81235e72b.svg";
export { ForwardRef as ReactComponent };